import axios from "axios";
import { Shop } from "../types/shop";

export async function getShop({
    shopId,
    page = 1,
}: {
    shopId: string;
    page?: number;
}) {
    try {
        const response = await axios.get(`/shop/${shopId}`, {
            params: { page },
        });
        const data = response.data;
        return data.data as Shop;
    } catch (error) {
        console.error(error);
    }
}
